"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReservableShowings = void 0;
var showings_1 = require("../../../types/showings");
var sorting_1 = require("../../sorting");
var filtering_1 = require("./filtering");
var openHouseReservables_1 = require("./openHouseReservables");
var personalReservables_1 = require("./personalReservables");
/** If best reservable is over 8 days from now, return reservable showings within 7 days
 *
 * Returns
 * - 1 reservation per day (bestReservable)
 * - unreserved showings not on a reservation/bestReservable day
 */
var getOpenHouseReservables = function (futureShowings) {
    var reservableShowings = {
        reservables: [],
        bestReservables: []
    };
    var reservedShowings = [];
    var unreservedShowings = [];
    futureShowings.forEach(function (futureShowing) {
        return showings_1.isReservedShowing(futureShowing)
            ? (reservedShowings = __spreadArrays(reservedShowings, [futureShowing]))
            : (unreservedShowings = __spreadArrays(unreservedShowings, [futureShowing]));
    });
    if (reservedShowings.length === 0) {
        reservableShowings.reservables = futureShowings;
        return reservableShowings;
    }
    reservableShowings = openHouseReservables_1.getOpenHouseReservablesAndBestReservables(reservedShowings, unreservedShowings);
    return reservableShowings;
};
/** A bit trickier.
 *
 * - reservables are any future showings without applicationId,
 * - reservations are personal showings with applicationId (reserved showing)
 * - bestReservables are next to a reservation (30 min gap between showings allowed)
 *
 * We don't return reserved personal showings!
 */
var getPersonalReservables = function (futureShowings) {
    var reservableShowings = {
        bestReservables: [],
        reservables: []
    };
    /** we want personal reservations so we can suggest from around them */
    var reservedShowings = [];
    var unreservedShowings = [];
    futureShowings.forEach(function (personalShowing) {
        return showings_1.isReservedShowing(personalShowing)
            ? (reservedShowings = __spreadArrays(reservedShowings, [personalShowing]))
            : (unreservedShowings = __spreadArrays(unreservedShowings, [personalShowing]));
    });
    if (reservedShowings.length === 0) {
        reservableShowings.reservables = unreservedShowings;
        return reservableShowings;
    }
    reservableShowings = personalReservables_1.getPersonalReservablesAndBestReservables(reservedShowings, unreservedShowings);
    return reservableShowings;
};
/** Filters showings into reservables and best reservables
 *
 * Get reservable showings and split them into best reservables and reservables
 *
 * Best reservables are either:
 *
 * reserved openHouse showings
 * or
 * personal showings close to other reserved personal showings
 *
 * They are in prioritized order for reservation
 *
 * Personal reservable showings:
 * - reservable showing close (within 30 min) to a reservation (bestReservable)
 * OR
 * - is not on the same day as reservations (reservable)
 *
 * openHouse:
 * - 1 reservation per day (bestReservable)
 * AND
 * - unreserved showings not on a reservation/bestReservable day
 */
var getReservableShowings = function (showings, showingsType) {
    var futureShowings = filtering_1.getFutureShowings(showings, true);
    var sortedFutureShowings = futureShowings.sort(sorting_1.compareStartDates);
    if (sortedFutureShowings.length > 0) {
        switch (showingsType) {
            case 'openHouse':
                return getOpenHouseReservables(sortedFutureShowings);
            case 'personal':
                return getPersonalReservables(sortedFutureShowings);
        }
    }
    else {
        return { reservables: [], bestReservables: [] };
    }
};
exports.getReservableShowings = getReservableShowings;
//# sourceMappingURL=reservables.js.map